<template>
    <div class="index">
        <div class="main">
          <div class="title">资讯<span style="color:#FE3B35 ">动态</span></div>
          <div class="des">NEWS AND TRENDS</div>
          <div class="top">
            <div class="box" :class="selectIndex==0?'active':''" @click="select(0)">公司资讯</div>
            <div class="box" :class="selectIndex==1?'active':''" @click="select(1)">活动资讯</div>
          </div>
          <div class="content"  v-if="false">
            <div class="box" v-for="i in list" :key="i" @click="goDetail()">
              <div style="overflow: hidden"><img src="@/assets/img/new1.png" alt="" ></div>
              <div class="con">
                <div>一个好的内容策略可以帮助用户参与你</div>
                <div>一个好的内容策略可以帮助吸引你的消费者，这将在增长中发挥作用</div>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
    /**
     *
     * @Author zzl
     * @Date 2020/11/20 14:28.
     */

    export default {
        mounted() {
          console.log(this.$route.query.type)
          if(this.$route.query.type==0||this.$route.query.type==1){
            this.selectIndex = this.$route.query.type
          }
        },
        components: {},
        props: {},
        data() {
            return {
              selectIndex:0,
              list:5,
            }
        },
        computed: {},
        methods: {
          select(index){
            this.selectIndex = index
            this.list = index==0?5:2
          },
          goDetail(){
            this.$router.push({path:'/newDetail'})
          }
        },
        watch: {},
        filters: {},
        beforeDestroy() {

        }
    }
</script>

<style lang="less" scoped>
.index{
  width: 100%;
  min-width: 1920px;
  .main{
    width: 100%;
    height: 1326px;
    position: relative;
    .title{
      position: absolute;
      top: 128px;
      left: 0;
      text-align: center;
      width: 100%;
      font-size: 36px;
      font-family: Source Han Sans CN;
      font-weight: 300;
      color: #232330;
      z-index: 9;
    }
    .des{
      position: absolute;
      top: 60px;
      left: 0;
      text-align: center;
      width: 100%;
      font-size: 100px;
      font-family: Source Han Sans CN;
      font-weight: 800;
      color: #F6F6F6;
    }
    .top{
      cursor: pointer;
      position: absolute;
      top: 266px;
      left: calc(50% - 500px);
      display: flex;
      .box{
        width: 500px;
        height: 100px;
        line-height: 100px;
        text-align: center;
        background: #F6F6F6;
        box-shadow: 0px 5px 10px 0px rgba(35, 35, 48, 0.05);
        border-radius: 0px 10px 10px 0px;
        font-size: 36px;
        font-family: Source Han Sans CN;
        font-weight: 300;
        color: #999999;
      }
      .box:first-child{
        border-radius: 10px 0px 0px 10px;
      }
      .active{
        color: #232330;
        background: #FFFFFF;
        box-shadow: 0px 5px 10px 0px rgba(35, 35, 48, 0.05);
      }
    }
    .content{
      position: absolute;
      width: 1300px;
      height: 335px;
      top: 32%;
      left: calc(50% - 650px);
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      .box{
        width: 400px;
        margin-bottom: 52px;
        margin-right: 30px;
        border: 1px solid #EEEEEE;
        box-shadow: 0px 5px 10px 0px rgba(35, 35, 48, 0.05);
        display: flex;
        flex-direction: column;
        overflow: hidden;
        .con{
          padding: 20px;
          div:first-child{
            font-size: 20px;
            font-family: Source Han Sans CN;
            font-weight: 600;
            color: #333333;
            line-height: 40px;
          }
          div:last-child{
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 300;
            color: #282331;
          }
        }
        img{
          width: 100%;
          height: 100%;
          transition: all .8s ease 0s;
          -webkit-transition: all .8s ease 0s;
          cursor: pointer;
        }
      }
      .box:hover{
        img{
          width: 120%;
          height: 120%;
          margin-left: -10%;
          margin-top: -10%;
        }
      }
    }
  }
}
</style>
